import qs from 'qs'
import React, { useRef } from 'react'
import { useLocation, useNavigate } from 'react-router'
import NewTicketModal from './NewTicketModal'
import TicketModal from './TicketModal'

function Ticket() {
  const modal = useRef()
  const createModal = useRef()

  const navigate = useNavigate()
  const { search, ...location } = useLocation()
  const { ticketId } = qs.parse(search, { ignoreQueryPrefix: true })

  const onClose = () => {
    if (ticketId) {
      const newSearch = search.replace(qs.stringify({ ticketId }), '')

      navigate(
        {
          pathname: location.pathname,
          hash: location.hash,
          search: newSearch === '?' ? '' : newSearch,
        },
        { replace: true, state: location.state }
      )
    }
  }

  if (ticketId === 'new') {
    return <NewTicketModal innerRef={createModal} onClose={onClose} />
  }

  if (ticketId) {
    return (
      <TicketModal innerRef={modal} onClose={onClose} ticketId={ticketId} />
    )
  }

  return null
}

export default Ticket
